import { Component, SimpleChanges, OnChanges, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform, Output, EventEmitter } from '@angular/core';
import { DatePipe, Location } from '@angular/common';
import { FormGroup, FormControl, UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, UntypedFormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as FileSaver from 'file-saver';
import { trigger, state, style, transition, animate, query, group, stagger } from '@angular/animations';
import { GlobalSearchService } from '../../../services/globalsearchservice.service';
import { GlobalsService } from '../../../services/globals.service';

@Component({
	selector: 'app-inventory-locations-create',
	templateUrl: './inventory-locations-create.component.html',
	styleUrls: ['./inventory-locations-create.component.scss'],
	animations: [
		trigger('grow', [
			transition(':enter', [
				style({ height: '0', width: '0' }),
				animate(200, style({ height: '*', width: '*' })),
				animate('200ms', style({ opacity: 1 })),
			]),
			transition(':leave', [
				animate(100, style({ height: 0, width: 0 })),
				animate('100ms', style({ opacity: 0 }))
			])
		]),
	]
})
export class InventoryLocationsCreateComponent implements OnInit, OnChanges, OnDestroy {

	@Input() editing: any = false;
	@Output() complete = new EventEmitter<any>();
	private destroy$ = new Subject<void>();

	saving = false;
	saveError: string | null = null;

	loccode: any = '';
	locselected = false;
	ld: any = [];
	term: any = '';

	taxgroup: any = '';
	taxes: any = [];
	currencies: any = [];
	bankaccounts: any = [];
	types: any = [];
	zones: any = [];
	areas: any = [];
	territories: any = [];
	countries: any = [];
	locationForm: any = false;
	//todo move this to config
	config: any =[];
	customertypes: any = [];
	//customerdata: any = [];
	holdreasons: any = [];
	terms: any = [];
	salestypes: any = [];
	salespeople: any = [];
	locations: any = [];
	defaults: any = [];
	alltaxes: any = false;
	shipvia: any = [];
	territory: any = [];
	paymethod: any = [];

	constructor(private route: ActivatedRoute, private location: Location, public router: Router, public cdr: ChangeDetectorRef, private globalSearchService: GlobalSearchService, private fb: UntypedFormBuilder, public globalsService: GlobalsService) {
		this.globalSearchService.configsubscription.pipe(takeUntil(this.destroy$)).subscribe(r => {
			this.config = r;
		});
		this.globalSearchService.taxgroups.pipe(takeUntil(this.destroy$)).subscribe((results: any) => {
			this.taxes = results;
			this.alltaxes = results;
		});
	}

	ngOnInit(): void {
		this.globalsService.getDefaultZones().pipe(takeUntil(this.destroy$)).subscribe(details => {
			this.zones = details;
		});
		this.globalsService.getCurrencies().pipe(takeUntil(this.destroy$)).subscribe(details => {
			this.currencies = details;
		});
		this.globalsService.getTerms().pipe(takeUntil(this.destroy$)).subscribe(details => {
			this.terms = details;
		});
		this.globalsService.getSalesTypes().pipe(takeUntil(this.destroy$)).subscribe(details => {
			this.salestypes = details;
		});
		this.globalsService.getAreas().pipe(takeUntil(this.destroy$)).subscribe(details => {
			this.areas = details;
		});
		this.globalsService.getSalesman().pipe(takeUntil(this.destroy$)).subscribe(details => {
			this.salespeople = details;
		});
		this.globalsService.getCustomerTypes().pipe(takeUntil(this.destroy$)).subscribe(details => {
			this.types = details;
		});
		this.globalsService.getHoldReasons().pipe(takeUntil(this.destroy$)).subscribe(details => {
			this.holdreasons = details;
		});
		this.globalsService.getTerritories().pipe(takeUntil(this.destroy$)).subscribe(details => {
			this.territory = details;
		});
		this.globalsService.getLocations().pipe(takeUntil(this.destroy$)).subscribe(details => {
			this.locations = details;
		});
		this.globalsService.getPaymentMethods().pipe(takeUntil(this.destroy$)).subscribe(details => {
			this.paymethod = details;
		});
		this.globalSearchService.shipvia.pipe(takeUntil(this.destroy$)).subscribe(details => {
			this.shipvia = details;
		});
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (!changes.editing) return;
		const current = changes.editing.currentValue;
		if (current === '' || current === null || current === undefined) {
			this.globalsService.getLocationDefaults({}).subscribe(details => {
				this.defaults = details || {};
				const defRegion = this.defaults.region || (this.config?.defaults?.region) || '';
				const defCountry = this.defaults.country || (this.config?.defaults?.country) || '';
				this.locationForm = this.fb.group({
					loccode: ['', [Validators.required]],
					locationname: ['', [Validators.required]],
					deladd1: ['', [Validators.required]],
					deladd2: ['', []],
					deladd3: ['', [Validators.required]],
					deladd4: [defRegion, [Validators.required]],
					deladd5: ['', [Validators.required]],
					deladd6: [defCountry, [Validators.required]],
					tel: ['', []],
					email: ['', []],
					contact: ['', [Validators.required]],
					fax: ['', []],
					receipt_message:['', []],
					taxgroupid:['', []],
					taxgroupid_cert:['', []],
					defcountry: [this.defaults.country,[]],
					defregion: [this.defaults.region,[]],
					defholdreason: [this.defaults.holdreason,[]],
					defcurrency: [this.defaults.currency,[]],
					defterms: [this.defaults.terms,[]],
					defsalestype: [this.defaults.salestype,[]],
					defcustomertype: [this.defaults.customertype,[]],
					defdiscount: [this.defaults.discount,[]],
					defcredit: [this.defaults.credit,[]],
					defemail_invoice: [this.defaults.email_invoice ? 'Y': 'N',[]],
					defrequirepo: [this.defaults.requirepo ? '1': '0',[]],
					defemail_statement: [this.defaults.email_statement ? 'Y': 'N',[]],
					definterest: [this.defaults.interest,[]],
					defwarehouse: [this.defaults.warehouse,[]],
					defshipvia: [this.defaults.shipvia,[]],
					defarea: [this.defaults.area,[]],
					defterritory: [this.defaults.territory,[]],
					defsalesperson: [this.defaults.salesman,[]],
					defdisabled: [this.defaults.disabled  ? '1': '0',[]],
					deftaxauth: [this.defaults.taxauth,[]],
					defbranchcode: [this.defaults.branchcode,[]],
					defpayment_method: [this.defaults.default_paymentmehod,[]],
				});
			});
			return;
		}
		if (this.editing && typeof this.editing === 'object') {
			this.globalsService.getLocationDefaults({ loccode: this.editing.loccode }).subscribe(details => {
				this.defaults = details;
				this.locationForm = this.fb.group({
					loccode: [this.editing.loccode, [Validators.required]],
					locationname: [this.editing.orignalname, [Validators.required]],
					deladd1: [this.editing.deladd1, [Validators.required]],
					deladd2: [this.editing.deladd2, []],
					deladd3: [this.editing.deladd3, [Validators.required]],
					deladd4: [this.editing.deladd4, [Validators.required]],
					deladd5: [this.editing.deladd5, [Validators.required]],
					deladd6: [this.editing.deladd6, [Validators.required]],
					tel: [this.editing.tel, []],
					email: [this.editing.email, []],
					contact: [this.editing.contact, [Validators.required]],
					fax: [this.editing.fax, []],
					receipt_message:[this.editing.receipt_message, []],
					taxgroupid:[this.editing.taxgroupid,  [Validators.required]],
					taxgroupid_cert:[this.editing.taxgroupid_cert,  [Validators.required]],
					defcountry: [this.defaults.country,[]],
					defregion: [this.defaults.region,[]],
					defholdreason: [this.defaults.holdreason,[]],
					defcurrency: [this.defaults.currency,[]],
					defterms: [this.defaults.terms,[]],
					defsalestype: [this.defaults.salestype,[]],
					defcustomertype: [this.defaults.customertype,[]],
					defdiscount: [this.defaults.discount,[]],
					defcredit: [this.defaults.credit,[]],
					defemail_invoice: [this.defaults.email_invoice ? 'Y': 'N',[]],
					defrequirepo: [this.defaults.requirepo ? '1': '0',[]],
					defemail_statement: [this.defaults.email_statement ? 'Y': 'N',[]],
					definterest: [this.defaults.interest,[]],
					defwarehouse: [this.defaults.warehouse,[]],
					defshipvia: [this.defaults.shipvia,[]],
					defarea: [this.defaults.area,[]],
					defterritory: [this.defaults.territory,[]],
					defsalesperson: [this.defaults.salesman,[]],
					defdisabled: [this.defaults.disabled  ? '1': '0',[]],
					deftaxauth: [this.defaults.taxauth,[]],
					defbranchcode: [this.defaults.branchcode,[]],
					defpayment_method: [this.defaults.default_paymentmehod,[]],
				});
				this.locationForm.get('loccode').disable();
			});
		}
	}

	updateZones(value: any) {
		if (!this.zones?.countries) return;
		const thisid = this.zones.countries.find((r: any) => r.name === value.value);
		if (thisid) {
			this.globalsService.getCountryZones(thisid.country_id).pipe(takeUntil(this.destroy$)).subscribe((details: any) => {
				this.zones.zones = details.zone || [];
				this.cdr.markForCheck();
			});
		}
	}

	updateLocation() {
		if (!this.locationForm || this.saving) return;
		this.locationForm.markAllAsTouched();
		if (this.locationForm.invalid) {
			this.saveError = 'Please fix the required fields.';
			this.globalSearchService.showNotification('Please fix the required fields.', 'warn', 'bottom', 'right');
			return;
		}
		this.saving = true;
		this.saveError = null;
		const raw = this.locationForm.getRawValue();
		const receiptVal = raw.receipt_message != null ? String(raw.receipt_message) : '';
		const payload = {
			...raw,
			receipt_message: this.globalSearchService.base64encode(receiptVal)
		};
		this.globalsService.updateLocation(payload).subscribe({
			next: () => {
				this.saving = false;
				this.globalSearchService.showNotification('Location saved successfully.', 'success', 'bottom', 'right');
				this.globalsService.getLocations().pipe(takeUntil(this.destroy$)).subscribe(r => {
					this.globalSearchService.locations.next(r);
				});
				this.complete.emit(true);
			},
			error: (err) => {
				this.saving = false;
				const msg = err?.error?.message || err?.message || err?.statusText || 'Save failed.';
				this.saveError = msg;
				this.globalSearchService.showNotification(msg, 'danger', 'bottom', 'right');
				this.cdr.markForCheck();
			}
		});
	}

	cancel() {
		this.complete.emit(true);
	}

	back(): void {
		this.location.back()
	}

	ngAfterViewInit() {

	}
}
